function useFormatDate() {
  const locale = 'et-EE';
  return (isoDateString: string, options?: Intl.DateTimeFormatOptions) =>
    new Intl.DateTimeFormat(locale, options).format(new Date(isoDateString));
}

export default useFormatDate;
